import { selectUserConfiguration } from '@/features/domain/user'
import { dateUtils } from '@/utils'
import { SelectChangeEvent } from '@mui/material'
import { getDay } from 'date-fns/esm'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

export function useOnChange(
  onChangeField: (value: uui.domain.ui.forms.RecurrenceSettings) => void,
) {
  const { today } = useSelector(selectUserConfiguration)

  return useCallback(
    (e: SelectChangeEvent<string>) => {
      const recurrencePeriodType = e.target
        .value as uui.domain.ui.forms.ExtendedRecurrencePeriodType

      onChangeField({
        recurrencePeriod: {
          recurrenceType: recurrencePeriodType,
          date: today,
          period: 1,
          weekday:
            recurrencePeriodType === 'WEEKLY'
              ? (getDay(dateUtils.parseDate(today)) as uui.domain.client.rm.WeekDay)
              : undefined,
        },
        recurrenceEnd: {
          endType: 'NEVER',
        },
      })
    },
    [onChangeField, today],
  )
}
